import React, { useEffect, useState } from "react";
import axios from "axios";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import moment from "moment";
import * as XLSX from "xlsx";
import { Button } from "@mui/material";
import Header from "./Header";
import DataTable from "react-data-table-component";
import TimeRangePicker from "./timepicker";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdMore } from "react-icons/io";

const endPoints = "https://api.gdswellness.com";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "80vh",
  overflowY: "auto",
  textAlign: "justify",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function Overview() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [CDeatils, setCDeatils] = useState([]);
  const [SelectedData, setSelectedData] = useState([]);
  const [limit, setLimit] = useState(10);

  const [deleteId, setDeleteId] = useState(null);

  const [total, setTotal] = useState(0);


  const [SDate, setSDate] = useState({
    start: "",
    end: "",
    starttime: "",
    endtime: "",
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setSDate(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [Preview, setPreview] = useState(false);

  const [openRowId, setOpenRowId] = useState(null);

  const handleActionClick = (id) => {

    setOpenRowId(openRowId === id ? null : id);
  };
  const columns = [
    // { name: "SI No", selector: row => row.index },
    { name: "Product name", selector: row => row.productName },
    { name: "Product order", selector: row => row.order },
    { name: "Pack Size", selector: row => row.packsize },
    { name: "Unit", selector: row => row.unit },
    { name: "SKU", selector: row => row.sku },
    { name: "Stock", selector: row => row.stockQuantity },
    { name: "stockStatus", selector: row => row.stockStatus },
    // { name: "Product Price", selector: row => row.page_slug },
    // { name: "Offer Price", selector: row => row.offerPrice },
    { name: "Status", selector: row => row.status ? "Active" : "Inactive" },
    // {
    //   name: "Date",
    //   selector: row => moment(row.createdAt).format("DD-MM-YY"),
    // },
    {
      name: "Action",
      cell: row => (
        <div >
          <IoMdMore
            onClick={(e) => {
              e.stopPropagation();
              handleActionClick(row._id);
            }}
          />

          {openRowId === row._id && (
            <div className="dropdown_list">
              <p
                style={{ cursor: "pointer", color: "red" }}
                onClick={() => handleDeleteSingle(row._id)}>
                Delete
              </p>
              <p
                style={{ cursor: "pointer", color: "skyblue" }}
                onClick={() => handleView(row._id)}>
                View
              </p>
              <p
                style={{ cursor: "pointer", color: "green" }}
                onClick={() => handleEdit(row._id)}>
                Edit
              </p>
            </div>
          )}
        </div>
      ),
    },
  ];

  const handleView = id => {
    setOpenRowId(null);
    navigate("/viewdetails", { state: { id } });
  };

  const handleEdit = idd => {
    setOpenRowId(null);
    navigate("/product", { state: { idd: idd } });
  };

  const handleDeleteSingle = (id) => {
    setOpenRowId(null);
    setDeleteId(id);
    setPreview(true);
  };

  useEffect(() => {
    const handleClickOutside = () => setOpenRowId(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);


  const handleDelete = async () => {
    try {
      // 🔹 Single delete
      if (deleteId) {
        await axios.post(`${endPoints}/api/product/trash/${deleteId}`);

        setCDeatils(prev => prev.filter(item => item._id !== deleteId));
        setDeleteId(null);
      }

      // 🔹 Multiple delete
      if (SelectedData.length > 0) {
        await Promise.all(
          SelectedData.map(item =>
            axios.post(`${endPoints}/api/product/trash/${item._id}`)
          )
        );

        setCDeatils(prev =>
          prev.filter(item => !SelectedData.some(s => s._id === item._id))
        );

        setSelectedData([]);
      }

      setPreview(false);
    } catch (error) {
      console.error(error);
    }
  };




  useEffect(() => {
    getProduct();
  }, [page, limit, SDate]);


  const getProduct = async () => {
    try {
      const res = await axios.get(
        `${endPoints}/api/product/admin?page=${page}&limit=${limit}`
      );

      setCDeatils(res.data.data);
      setTotal(res.data.total);
    } catch (error) {
      console.error(error);
    }
  };


  const handleSelecteRow = state => {
    setSelectedData(state.selectedRows);
  };

  const filterDateswise = data => {
    return data?.filter(item => {
      const createdAtMoment = moment(item?.createdAt);
      const selectedStartDate = SDate.start
        ? moment(SDate.start, "YYYY-MM-DD")
        : null;
      const selectedEndDate = SDate.end
        ? moment(SDate.end, "YYYY-MM-DD")
        : null;

      if (selectedStartDate && selectedEndDate) {
        return createdAtMoment.isBetween(
          selectedStartDate,
          selectedEndDate,
          null,
          "[]"
        );
      }

      if (selectedStartDate) {
        return createdAtMoment.isSameOrAfter(selectedStartDate);
      }

      if (selectedEndDate) {
        return createdAtMoment.isSameOrBefore(selectedEndDate);
      }

      return true;
    });
  };

  const filteredData = filterDateswise(CDeatils);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (!userData) {
      window.location.assign("/");
    }
  }, []);
  const [viewProduct, setViewProduct] = useState(false);

  const handleNavigate = () => {
    navigate("/product");
  };
  return (
    <>
      <Header />

      {viewProduct ? (
        <div className="row p-4">
          <div className="col-md-1 ">
            <img
              width={30}
              onClick={() => setViewProduct(false)}
              style={{ cursor: "pointer" }}
              height={30}
              src="../Assests/icons8-go-back-26.png"
              alt=""
            />
          </div>
          <div className="row">
            <div className="col-md-4"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="row m-auto">
            <div className="col-md-2">
              <label className="fw-bold">Select Date</label>
              <input
                className="col-md-12 mb-2 shadow"
                type="date"
                onChange={handleChange}
                name="start"
              />
            </div>
            <div className="col-md-2">
              <label className="fw-bold">End Date</label>
              <input
                className="col-md-12 mb-2 shadow"
                type="date"
                name="end"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-2 mt-4">
              {SelectedData?.length > 0 && (
                <button
                  className="row m-auto p-2"
                  style={{
                    border: "none",
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "6px",
                  }}
                  onClick={() => setPreview(true)}>
                  Delete
                </button>
              )}
            </div>

          </div>
          <div className="row ">
            <div className="col-md-10"></div>
            <button
              className="add-btn mb-2 col-md-2 mt-2 p-2 mx-auto"
              onClick={handleNavigate}>
              Add Product
            </button>
          </div>
          <DataTable
            columns={columns}
            data={CDeatils}
            pagination
            paginationServer
            paginationTotalRows={total}
            paginationPerPage={limit}
            onChangePage={(page) => setPage(page)}
            onChangeRowsPerPage={(newLimit, page) => {
              setLimit(newLimit);
              setPage(page);
            }}
          />


          <Modal open={Preview} onClose={() => setPreview(false)}>
            <Box sx={style}>
              <h5>
                {deleteId
                  ? "Do you really want to delete this product?"
                  : `Do you really want to delete ${SelectedData.length} products?`}
              </h5>

              <p style={{ color: "gray" }}>
                This action cannot be undone.
              </p>

              <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setPreview(false);
                    setDeleteId(null);
                    setSelectedData([]);
                  }}
                >
                  No
                </Button>

                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                >
                  Yes, Delete
                </Button>
              </Box>
            </Box>
          </Modal>

        </>
      )}
    </>
  );
}
